import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const HeaderStyled = styled('header')<{ hideNavigationMenu?: boolean }>(
  ({ theme, hideNavigationMenu }) => ({
    backgroundColor:
      theme.palette.mode === 'dark' ? Colors.black : Colors.white,
    borderBottom: !hideNavigationMenu ? `1px solid ${Colors.gray200}` : 'none',
    height: 64,
    width: '100%',
    display: 'flex',

    '.header-wrapper': {
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
      flex: 1,
      gap: 16,
      width: '100%',

      '.header-logo': {
        display: 'flex',
        width: 126,
        height: 44,
      },

      '.header-logoShort': {
        display: 'flex',
        width: 20,
        height: 32,
      },

      '.header-left': {
        width: '100%',
      },

      '.header-right': {
        gap: 12,
        display: 'flex',
        alignItems: 'center',
      } as CSSObject,
    },
  })
);
